import type { Entity } from '@ots-frontend/ots-data';
import { RrcEp9WasteProfilesPage } from '@ots-frontend/ots-ui-tw';
import type { CardProps } from '../Card/Card';
export type RrcEp9WasteProfileDataTableCardProps = CardProps & {
  entity: Entity;
};
export const RrcEp9WasteProfileDataTableCard = ({
  entity,
}: RrcEp9WasteProfileDataTableCardProps) => (
  <RrcEp9WasteProfilesPage
    objectId={entity.id}
    objectType={entity.entityType}
    objectName={entity.displayName}
    embedded
  />
);
